import moment from "moment-timezone"

export default {
    methods: {
        dateFormat(dateString, format, timezone) {
            return moment.tz(dateString, timezone ?? "America/New_York").format(format ?? "MMM DD, YYYY, h:mm A")
        },
    },
}
